import React, { useState, useContext } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { Button } from 'grommet';

import { AppContext } from '../../../context';
import { postAuthenticate } from '../../../api';
import { Alert } from '../../../components';

import urlRoutes from '../../../config/url-routes';
import { setItemStorage } from '../../../commons';

const EyeIcon = () => (
  <svg width='20' height='20' viewBox='0 0 24 24' fill='none'>
    <path
      d='M2 12C3.427 8.007 7.362 5 12 5c4.638 0 8.573 3.007 10 7-1.427 3.993-5.362 7-10 7-4.638 0-8.573-3.007-10-7Z'
      stroke='currentColor'
      strokeWidth='1.6'
      strokeLinejoin='round'
    />
    <circle cx='12' cy='12' r='3' stroke='currentColor' strokeWidth='1.6' />
  </svg>
);

const EyeOffIcon = () => (
  <svg width='20' height='20' viewBox='0 0 24 24' fill='none'>
    <path
      d='M3 3L21 21M10.584 10.587A2 2 0 0012 14a2 2 0 001.415-.586M9.363 5.365A9.466 9.466 0 0112 5c4.638 0 8.573 3.007 10 7-.512 1.432-1.34 2.72-2.412 3.775M6.61 6.61C4.6 7.86 3.02 9.723 2 12c1.427 3.993 5.362 7 10 7 1.394 0 2.72-.27 3.938-.762'
      stroke='currentColor'
      strokeWidth='1.6'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

// Wordmark "Kenlo" — mesmo path do componente Logo do KDLS (variant="primary")
const KenloWordmark = () => (
  <svg width='98' height='28' viewBox='0 0 84 24' fill='none' xmlns='http://www.w3.org/2000/svg' aria-label='Kenlo'>
    <path
      d='M26.4412 13.8352C26.7927 12.6265 27.5266 11.5646 28.5324 10.809C29.5382 10.0534 30.762 9.64497 32.0194 9.64497C33.2769 9.64497 34.5007 10.0534 35.5064 10.809C36.5122 11.5646 37.2459 12.6265 37.5974 13.8352H26.4412ZM32.0194 6.65851C27.1643 6.65851 23.2046 10.5505 23.2046 15.3238C23.2046 20.9374 27.807 24.0374 32.6473 23.989C34.0594 23.9835 35.4622 23.762 36.8076 23.3321C37.6867 23.0346 38.1498 22.2847 37.865 21.5163C37.605 20.8184 36.9982 20.4478 35.9754 20.6771C34.8896 20.925 34.2309 21.0056 32.7561 21.0056C29.382 21.0056 26.8314 19.2567 26.4412 16.8161H38.614C39.6902 16.8161 41.0447 16.3203 40.7674 14.2392C40.2001 9.98034 36.5004 6.65851 32.0194 6.65851ZM23.0832 21.3787C23.227 21.5205 23.3414 21.6893 23.4197 21.8755C23.4979 22.0618 23.5386 22.2616 23.5393 22.4637C23.5401 22.6657 23.5008 22.8659 23.4239 23.0527C23.347 23.2394 23.2339 23.4091 23.0911 23.552C22.9484 23.6948 22.7788 23.8079 22.5922 23.8848C22.4055 23.9617 22.2055 24.0008 22.0037 24C21.8019 23.9991 21.6022 23.9583 21.4163 23.8798C21.2303 23.8014 21.0616 23.6868 20.9201 23.5428L11.958 14.6098L2.85591 23.5515C2.57053 23.8318 2.18717 23.9897 1.78733 23.9915C1.58931 23.9885 1.39344 23.9499 1.20909 23.8775C0.933868 23.7668 0.697648 23.5769 0.530346 23.3318C0.363043 23.0866 0.272187 22.7973 0.269287 22.5004V1.53943C0.280705 1.13463 0.449367 0.750251 0.739428 0.467974C1.02949 0.185697 1.41808 0.0277756 1.82262 0.0277756C2.22716 0.0277756 2.61575 0.185697 2.90582 0.467974C3.19586 0.750251 3.36453 1.13463 3.37594 1.53943V18.7683L19.7091 2.70331C19.996 2.41617 20.385 2.25484 20.7907 2.25484C21.1964 2.25484 21.5854 2.41617 21.8723 2.70331C22.1591 2.99046 22.3203 3.37992 22.3203 3.786C22.3203 4.19208 22.1591 4.58154 21.8723 4.86869L14.0864 12.5163L23.0832 21.3787ZM64.5186 1.47622V22.5004C64.5073 22.8958 64.3426 23.2711 64.0593 23.5468C63.7759 23.8224 63.3962 23.9766 63.0012 23.9766C62.6062 23.9766 62.2265 23.8224 61.9431 23.5468C61.66 23.2711 61.4951 22.8958 61.4837 22.5004V1.47622C61.4951 1.08087 61.66 0.705497 61.9431 0.42985C62.2265 0.154201 62.6062 0 63.0012 0C63.3962 0 63.7759 0.154201 64.0593 0.42985C64.3426 0.705497 64.5073 1.08087 64.5186 1.47622ZM59.442 15.0424V22.5004C59.4307 22.8958 59.2658 23.2711 58.9826 23.5468C58.6993 23.8224 58.3196 23.9766 57.9246 23.9766C57.5295 23.9766 57.1499 23.8224 56.8665 23.5468C56.5831 23.2711 56.4184 22.8958 56.4071 22.5004V15.0424C56.4071 12.059 53.9505 9.64444 50.9156 9.64444C47.8809 9.64444 45.4243 12.059 45.4243 15.0424V22.5004C45.413 22.8958 45.2481 23.2711 44.9647 23.5468C44.6813 23.8224 44.3019 23.9766 43.9069 23.9766C43.5116 23.9766 43.1322 23.8224 42.8488 23.5468C42.5654 23.2711 42.4007 22.8958 42.3894 22.5004V15.0424C42.3894 10.4253 46.2191 6.661 50.9156 6.661C55.6123 6.661 59.442 10.4253 59.442 15.0424ZM74.9196 21.0081C73.8904 21.0092 72.8789 20.7399 71.9862 20.2272C71.643 20.025 71.3189 19.7918 71.0179 19.5306C70.6468 19.2015 70.3212 18.8242 70.0496 18.4089C69.4447 17.5006 69.1228 16.4328 69.1248 15.3411C69.1248 12.2015 71.7114 9.65807 74.906 9.65807C78.1006 9.65807 80.6859 12.2015 80.6859 15.3411C80.6859 18.4807 78.1142 21.0081 74.9196 21.0081ZM74.9196 6.661C70.0645 6.661 66.1048 10.5542 66.1048 15.3263C66.1055 16.9922 66.5926 18.6216 67.5065 20.014C67.9255 20.6482 68.4238 21.226 68.9898 21.7332C69.4426 22.1324 69.9312 22.4888 70.4497 22.7979C71.8072 23.5828 73.3481 23.9945 74.9158 23.9915C79.7709 23.9915 83.7306 20.0995 83.7306 15.3263C83.7306 10.553 79.7795 6.65851 74.9233 6.65851'
      fill='#298EE6'
    />
  </svg>
);

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [erro, setErro] = useState(false);
  const [message, setMessage] = useState('Informe o e-mail e a senha.');

  const context = useContext(AppContext);
  const history = useHistory();

  const handleSubmit = async () => {
    if (!email || !password) {
      setErro(true);
      setMessage('Informe o e-mail e a senha.');
      return false;
    }

    setLoading(true);

    try {
      const { data } = await postAuthenticate({
        email,
        password,
      });

      setItemStorage(process.env.REACT_APP_TOKEN_AUTH_NAME, data.token);
      context.loadUserData();
      history.push(urlRoutes.migrationsUrl);
    } catch (error) {
      setErro(true);
      setMessage('E-mail ou senha não conferem.');
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (event) => {
    if (event.key === 'Enter') handleSubmit();
  };

  if (context.authenticated) {
    return <Redirect to={urlRoutes.migrationsUrl} />;
  }

  return (
    <div className='login-container'>
      <div className='login-left' />

      <div className='login-right'>
        <div className='login-panel'>

          <div className='login-brand'>
            <KenloWordmark />
            <span className='login-brand__product'>Migrações</span>
          </div>

          <div>
            <div className='login-heading-row'>
              <h1 className='login-title'>Entrar</h1>
              <span className='login-tag'>Base Homologação</span>
            </div>
            <p className='login-lead'>Acesse com login e senha informado pelo consultor.</p>
          </div>

          <div className='login-fields'>
            <div className='login-field'>
              <div className='login-field__body'>
                <input
                  className='login-field__input'
                  name='email'
                  type='email'
                  placeholder=' '
                  autoComplete='username'
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                  onKeyDown={handleKeyDown}
                />
                <label className='login-field__label'>E-mail</label>
              </div>
            </div>

            <div className='login-field'>
              <div className='login-field__body'>
                <input
                  className='login-field__input'
                  name='password'
                  type={showPassword ? 'text' : 'password'}
                  placeholder=' '
                  autoComplete='current-password'
                  value={password}
                  onChange={(event) => setPassword(event.target.value)}
                  onKeyDown={handleKeyDown}
                />
                <label className='login-field__label'>Senha</label>
              </div>
              <button
                type='button'
                className='login-password-toggle'
                aria-label={showPassword ? 'Ocultar senha' : 'Mostrar senha'}
                onClick={() => setShowPassword((prev) => !prev)}
              >
                {showPassword ? <EyeOffIcon /> : <EyeIcon />}
              </button>
            </div>
          </div>

          {erro && <Alert alertType='error' message={message} />}

          <Button
            primary
            fill='horizontal'
            size='large'
            className='login-submit'
            label={!loading ? 'ENTRAR' : 'AUTENTICANDO...'}
            disabled={loading}
            onClick={handleSubmit}
          />

        </div>
      </div>
    </div>
  );
};

export default Login;
